<div *ngIf="!showSorryMessage; else showSorry" class="scrolling-panel-container">
  <div>
    <h3 class="title">Congratulations!</h3>
    <div *ngIf="numberOfBuyers > 1" class="instruction-body sub-title">
      There are {{ numberOfBuyers }} possible buyers for your carbon offset site. In the subsequent steps, you may see a
      range of valuations until a buyer is selected. You can change any part of your site, including the buyer, until
      you submit to CORE Carbon for review.
    </div>
    <div *ngIf="numberOfBuyers === 1" class="instruction-body sub-title">
      There is a buyer for your carbon offset site. You can change any part of your site until you submit to CORE Carbon
      for review.
    </div>
    <br />
    <br />
    <br />
    <h3 class="title">Before Continuing...</h3>
    <div class="instruction-body sub-title">
      Please respond to the questions below to ensure you are eligible for our program
    </div>
    <form [formGroup]="eligibilityForm">
      <div class="instruction-body question-container">
        <div class="number">1.</div>
        <div class="question-body">
          <span>I own this property, or am acting on behalf of someone who owns this property</span>
          <mat-radio-group formControlName="isOwner">
            <mat-radio-button [value]="true">Yes</mat-radio-button>
            <mat-radio-button [value]="false">No</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <div class="instruction-body question-container">
        <div class="number">2.</div>
        <div class="question-body">
          <span>
            The legal owner of the enrolled acres owns less than 5,000 forested acres in the United States and is not
            engaged in the primary processing of raw wood products.
            <fa-icon
              #tooltip="matTooltip"
              (click)="tooltip.toggle()"
              [icon]="['far', 'circle-info']"
              class="blue"
              matTooltip="This methodology has a requirement that the landowner owns no more than 5,000 forested acres. This requirement is assessed and contained at the entity who holds the title to the real property and/or controls the rights to the timber in the site area. The form of ownership may be by one or more individuals or a legal entity, for example, a partnership, LLC or Trust."
              matTooltipClass="fc-tooltip"
              matTooltipPosition="right"></fa-icon>
          </span>
          <mat-radio-group formControlName="under5000Acres">
            <mat-radio-button [value]="true">Yes</mat-radio-button>
            <mat-radio-button [value]="false">No</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </form>
  </div>
</div>

<ng-template #showSorry>
  <div class="scrolling-panel-container sorry">
    <div>
      <h3 class="title">We’re Sorry, You May Not Be Eligible For This Carbon Offset Program</h3>
      <div class="instruction-body sub-title">
        Based on one or more of your responses, your site may not be eligible for this carbon offset program. Please
        <a href="mailto:{{ helpEmail }}">email us</a>
        if you have any further questions.
      </div>
    </div>
  </div>
</ng-template>

<mat-card *ngIf="!showSorryMessage; else showSorryFooter" appearance="outlined" class="bottom-container">
  <div class="button-container">
    <div (click)="goBack(true)" class="link-container fc-link" data-cy="button-back">
      <fa-icon [icon]="['far', 'arrow-left']" class="blue size-20"></fa-icon>
      Back
    </div>
    <button
      (click)="onClickContinue()"
      color="primary"
      data-cy="button-continue"
      disabled="{{ eligibilityForm.invalid }}"
      mat-raised-button
      type="button">
      Continue
    </button>
  </div>
</mat-card>

<ng-template #showSorryFooter>
  <mat-card appearance="outlined" class="bottom-container">
    <div class="button-container">
      <div (click)="goBack()" class="link-container fc-link" data-cy="button-back">
        <fa-icon [icon]="['far', 'arrow-left']" class="blue size-20"></fa-icon>
        Back
      </div>
      <button
        (click)="goToRoot()"
        class="button return"
        color="primary"
        data-cy="button-return"
        mat-raised-button
        type="button">
        Return to Home Page
      </button>
    </div>
  </mat-card>
</ng-template>
